// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brb-btn {\n  transition: all ease-in-out 0.3s;\n}\n.brb-btn:not(.custom-radius) {\n  border-radius: 1.25rem;\n}\n.brb-btn:not(.custom-padding) {\n  padding: 0.25rem 1.25rem;\n}", ""]);
// Exports
module.exports = exports;
